// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"97":"79cb3df3","188":"254a19a7","379":"a9514dd5","453":"72d57bbf","566":"9dfa66d1","657":"5eb71682","662":"bfdccf01","922":"80476d5d"}[chunkId] + ".chunk.js";
};